import { transferDashboardTilesDataToClient } from "./transfer-dashboard-tiles-data-to-client";

export const transferDashboards = async (dashboardId, dashboardDataTiles) => {
  if (!dashboardId && dashboardDataTiles.length === 0) {
    return {
      success: true,
      data: null,
      message: "No dashboard data to transfer",
    };
  }
  try {
    const data = await transferDashboardTilesDataToClient(
      dashboardId,
      dashboardDataTiles,
    );

    // If data is undefined or null, treat as failure
    // because updateBlueprintDashboardInClient and createBlueprintDashboardInClient
    // swallow errors (they reroute and that's it)
    if (data === undefined || data === null) {
      return {
        success: false,
        error: new Error("Failed to transfer dashboards"),
        message: "Failed to transfer dashboards",
      };
    }

    return { success: true, data, message: "Dashboards transferred" };
  } catch (error) {
    // Just in case some error would come back
    return { success: false, error, message: "Failed to transfer dashboards" };
  }
};
